<template>
    <select/>
</template>
<script>
    import $ from 'jquery';
    import selectize from 'selectize';
    import 'selectize/dist/css/selectize.bootstrap3.css';

    export default {
        props: ['value', 'load', 'options', 'labelField', 'searchField', 'valueField', 'placeholder', 'maxOptions', 'openOnFocus', 'allowEmpty', 'render', 'focus', 'clearSelection'],
        data: function () {
            return {
                selectize: {}
            }
        },
        watch: {
            options: function (value, old) {
                //console.log("options changed", value)
                this.selectize.clearOptions();
                this.selectize.renderCache = {};
                this.selectize.load(function (callback) {
                    callback(value);

                });
                //console.log("Current Value ", this.value.id)
                this.selectize.setValue(this.value.id, true);
            },
            clearSelection() {
                this.selectize.clear();
                this.selectize.clearOptions();
            },
            value: function (value, old) {
                console.log("Selectize value changed", value)
                this.setValue(value);
            },
            focus() {
                if (focus) {
                    this.selectize.focus();
                }
            }
        },
        mounted: function () {
            this.initialize();
        },
        methods: {
            initialize: function () {
                var params = {
                    options: [],
                    //selectOnTab: true
                }

                params.loadThrottle = 300;
                params.persist = false;
                if (this.$props.options) {
                    params.options = this.$props.options;
                }
                else if (this.$props.load) {
                    params.load = this.$props.load;
                }


                if (this.$props.render) params.render = this.$props.render;
                if (this.$props.valueField) params.valueField = this.$props.valueField;
                if (this.$props.labelField) params.labelField = this.$props.labelField;
                if (this.$props.searchField) params.searchField = this.$props.searchField;

                if (this.$props.maxOptions) {
                    params.maxOptions = this.$props.maxOptions;
                }
                //else {
                //    params.maxOptions = 5;
                //}

                if (this.$props.placeholder) params.placeholder = this.$props.placeholder;
                if (this.$props.openOnFocus) params.openOnFocus = this.$props.openOnFocus;
                if (this.$props.allowEmpty) params.allowEmpty = this.$props.allowEmpty;


                var that = this;
                params.onChange = function (value) {
                    var selectedObject = that.selectize.options[value];
                    //that.$props.value = selectedObject;
                    that.$emit('input', selectedObject);
                    console.log("Object Selected", that.value)
                }
                params.onBlur = function () {
                    var selectedValue = that.selectize.getValue();
                    var selectedObject = that.selectize.options[selectedValue];
                    //that.$props.value = selectedObject;
                    that.$emit('input', selectedObject);
                    console.log("Object Selected", that.value)
                }
                //console.log("Initializing Selectize with options ", params)

                var select = $(this.$el).selectize(params);
                this.selectize = select[0].selectize;


                if (this.value) {
                    //console.log("Selectize value setting inital ", this.value)
                    this.selectize.setValue(this.value, true);
                }
            },

            setValue: function (obj) {
                var id = obj[this.valueField];
                console.log("Selectize value setting to value field", id)
                this.selectize.setValue(id, true);
            }
        }
    }

</script>



// WEBPACK FOOTER //
// selectize.scp.html?78b742f6